import BaseFilterModel from "./BaseFilterModel";
import { computed, observable, action } from "mobx";
import isFunction from "lodash/isFunction";
import isNull from "lodash/isNull";
import FormModel from "../../FormModel";

class TypeaheadFilterModel extends BaseFilterModel {
    @observable typeaheadForm;

    constructor(definition) {
        super(definition);
        this.endpoint = definition.endpoint;
        this.typeaheadForm = new FormModel({});
    }

    get key() {
        return this.definition.name || "typeahead";
    }

    @computed
    get func() {
        return rowData => {
            const rowValue = rowData.get(this.columnName);
            if (isFunction(this.definition.compareFunction)) {
                return this.definition.compareFunction(rowValue, this.value);
            } else {
                return !isNull(rowValue) && rowValue.toString().toLowerCase() === this.value.toLowerCase();
            }
        };
    }

    @computed
    get typeaheadValue() {
        return this.typeaheadForm.get("typeaheadValue");
    }

    get defaultValue() {
        return super.defaultValue || "";
    }

    @action
    updateValue(newValue) {
        this.typeaheadForm.set("typeaheadValue", newValue);
        this.value = this.typeaheadForm.get("typeaheadValue");
    }
}

export default TypeaheadFilterModel;
